export default __webpack_public_path__ + "static/media/mobile-half.fa833058.png";